<template>
  <div class="currentTable">
    <div class="name">
      <h4 v-if="calculationData.answer === 'Yes'" class="snd-name">
        Standard Normal Distribution Table
      </h4>
      <div v-else class="t-table">
        <h4>
          Student’s T-Distribution Table
        </h4>
        <span>Area in Upper Tail</span>
      </div>
    </div>
    <div class="table-wrapper">
      <table>
        <tr>
          <th>{{ abbreviation }}</th>
          <th>{{ dynamicNumbers[1] }}</th>
          <th>{{ dynamicNumbers[2] }}</th>
          <th>{{ dynamicNumbers[3] }}</th>
          <th>{{ dynamicNumbers[4] }}</th>
          <th>{{ dynamicNumbers[5] }}</th>
        </tr>
        <tr>
          <td :class="{ 'color': isActive[6] }">
            {{ dynamicNumbers[6] }}
          </td>
          <td :class="{ 'color': isActive[7], 'current-score': isActive.score7 }">
            {{ Number(dynamicNumbers[7]).toFixed(currentRoundingNumber) }}
          </td>
          <td :class="{ 'color': isActive[8], 'current-score': isActive.score8 }">
            {{ Number(dynamicNumbers[8]).toFixed(currentRoundingNumber) }}
          </td>
          <td :class="{ 'color': isActive[9], 'current-score': isActive.score9 }">
            {{ Number(dynamicNumbers[9]).toFixed(currentRoundingNumber) }}
          </td>
          <td :class="{ 'color': isActive[10], 'current-score': isActive.score10 }">
            {{ Number(dynamicNumbers[10]).toFixed(currentRoundingNumber) }}
          </td>
          <td :class="{ 'color': isActive[11], 'current-score': isActive.score11 }">
            {{ Number(dynamicNumbers[11]).toFixed(currentRoundingNumber) }}
          </td>
        </tr>
        <tr>
          <td :class="{ 'color': isActive[12] }">
            {{ dynamicNumbers[12] }}
          </td>
          <td :class="{ 'color': isActive[13], 'current-score': isActive.score13 }">
            {{ Number(dynamicNumbers[13]).toFixed(currentRoundingNumber) }}
          </td>
          <td :class="{ 'color': isActive[14], 'current-score': isActive.score14 }">
            {{ Number(dynamicNumbers[14]).toFixed(currentRoundingNumber) }}
          </td>
          <td :class="{ 'color': isActive[15], 'current-score': isActive.score15 }">
            {{ Number(dynamicNumbers[15]).toFixed(currentRoundingNumber) }}
          </td>
          <td :class="{ 'color': isActive[16], 'current-score': isActive.score16 }">
            {{ Number(dynamicNumbers[16]).toFixed(currentRoundingNumber) }}
          </td>
          <td :class="{ 'color': isActive[17], 'current-score': isActive.score17 }">
            {{ Number(dynamicNumbers[17]).toFixed(currentRoundingNumber) }}
          </td>
        </tr>
        <tr>
          <td :class="{ 'color': isActive[18] }">
            {{ dynamicNumbers[18] }}
          </td>
          <td :class="{ 'color': isActive[19], 'current-score': isActive.score19 }">
            {{ Number(dynamicNumbers[19]).toFixed(currentRoundingNumber) }}
          </td>
          <td :class="{ 'color': isActive[20], 'current-score': isActive.score20 }">
            {{ Number(dynamicNumbers[20]).toFixed(currentRoundingNumber) }}
          </td>
          <td :class="{ 'color': isActive[21], 'current-score': isActive.score21 }">
            {{ Number(dynamicNumbers[21]).toFixed(currentRoundingNumber) }}
          </td>
          <td :class="{ 'color': isActive[22], 'current-score': isActive.score22 }">
            {{ Number(dynamicNumbers[22]).toFixed(currentRoundingNumber) }}
          </td>
          <td :class="{ 'color': isActive[23], 'current-score': isActive.score23 }">
            {{ Number(dynamicNumbers[23]).toFixed(currentRoundingNumber) }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    currentScore: { type: Number, default: 0 },
    currentTable: { type: Array, default: () => {} },
  },
  data() {
    return {
      isActive: {
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
        11: false,
        12: false,
        13: false,
        14: false,
        15: false,
        16: false,
        17: false,
        18: false,
        19: false,
        20: false,
        21: false,
        22: false,
        23: false,
        score6: false,
        score7: false,
        score8: false,
        score9: false,
        score10: false,
        score11: false,
        score12: false,
        score13: false,
        score14: false,
        score15: false,
        score16: false,
        score17: false,
        score18: false,
        score19: false,
        score20: false,
        score21: false,
        score22: false,
        score23: false,
      },
      dynamicNumbers: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 0,
        20: 0,
        21: 0,
        22: 0,
        23: 0,
      },
    };
  },
  computed: {
    ...mapState('calculators', ['calculationData']),
    abbreviation() {
      return this.calculationData.answer === 'Yes' ? 'z' : 'd.f./α';
    },
    currentRoundingNumber() {
      return this.calculationData.answer === 'Yes' ? 4 : 3;
    },
  },
  mounted() {
    let breakLoops = false;

    for (let i = 0; i < this.currentTable.length && !breakLoops; i += 1) {
      for (let y = 0; y < this.currentTable[i].length && !breakLoops; y += 1) {
        if (this.currentTable[i][y] === this.currentScore) {
          if (this.calculationData.answer === 'Yes') {
            if (this.currentTable[i][y + 2] !== undefined && this.currentTable[i][y - 2] !== undefined) {
              this.dynamicNumbers[1] = (y - 2) / 100;
              this.dynamicNumbers[2] = (y - 1) / 100;
              this.dynamicNumbers[3] = y / 100;
              this.dynamicNumbers[4] = (y + 1) / 100;
              this.dynamicNumbers[5] = (y + 2) / 100;
            } else if (this.currentTable[i][y - 2] === undefined && this.currentTable[i][y - 1] !== undefined) {
              this.dynamicNumbers[1] = (y - 1) / 100;
              this.dynamicNumbers[2] = y / 100;
              this.dynamicNumbers[3] = (y + 1) / 100;
              this.dynamicNumbers[4] = (y + 2) / 100;
              this.dynamicNumbers[5] = (y + 3) / 100;
            } else if (this.currentTable[i][y + 2] === undefined && this.currentTable[i][y + 1] !== undefined) {
              this.dynamicNumbers[1] = (y - 3) / 100;
              this.dynamicNumbers[2] = (y - 2) / 100;
              this.dynamicNumbers[3] = (y - 1) / 100;
              this.dynamicNumbers[4] = y / 100;
              this.dynamicNumbers[5] = (y + 1) / 100;
            } else if (this.currentTable[i][y - 1] === undefined) {
              this.dynamicNumbers[1] = y / 100;
              this.dynamicNumbers[2] = (y + 1) / 100;
              this.dynamicNumbers[3] = (y + 2) / 100;
              this.dynamicNumbers[4] = (y + 3) / 100;
              this.dynamicNumbers[5] = (y + 4) / 100;
            } else if (this.currentTable[i][y + 1] === undefined) {
              this.dynamicNumbers[1] = (y - 4) / 100;
              this.dynamicNumbers[2] = (y - 3) / 100;
              this.dynamicNumbers[3] = (y - 2) / 100;
              this.dynamicNumbers[4] = (y - 1) / 100;
              this.dynamicNumbers[5] = y / 100;
            }

            if (this.currentTable[i + 1] !== undefined && this.currentTable[i - 1] !== undefined) {
              this.dynamicNumbers[6] = (i - 1) / 10;
              this.dynamicNumbers[12] = (i) / 10;
              this.dynamicNumbers[18] = ((i + 1) / 10).toFixed(1);
            } else if (this.currentTable[i + 1] !== undefined && this.currentTable[i - 1] === undefined) {
              this.dynamicNumbers[6] = i / 10;
              this.dynamicNumbers[12] = (i + 1) / 10;
              this.dynamicNumbers[18] = ((i + 2) / 10).toFixed(1);
            } else if (this.currentTable[i - 1] !== undefined && this.currentTable[i + 1] === undefined) {
              this.dynamicNumbers[6] = (i - 2) / 10;
              this.dynamicNumbers[12] = (i - 1) / 10;
              this.dynamicNumbers[18] = (i / 10).toFixed(1);
            }
          } else if (i + 1 < 30) {
            if (!this.currentTable[i - 1]) {
              this.dynamicNumbers[6] = i + 1;
              this.dynamicNumbers[12] = i + 2;
              this.dynamicNumbers[18] = i + 3;
            } else if (!this.currentTable[i - 2]) {
              this.dynamicNumbers[6] = i;
              this.dynamicNumbers[12] = i + 1;
              this.dynamicNumbers[18] = i + 2;
            } else if (!this.currentTable[i + 1]) {
              this.dynamicNumbers[6] = i - 1;
              this.dynamicNumbers[12] = i;
              this.dynamicNumbers[18] = i + 1;
            } else {
              this.dynamicNumbers[6] = i;
              this.dynamicNumbers[12] = i + 1;
              this.dynamicNumbers[18] = i + 2;
            }
          } else if (!this.currentTable[i + 1] || !this.currentTable[i + 2]) {
            this.dynamicNumbers[6] = 60;
            this.dynamicNumbers[12] = 120;
            this.dynamicNumbers[18] = 'inf.';
          } else if (!this.currentTable[i + 3]) {
            this.dynamicNumbers[6] = 50;
            this.dynamicNumbers[12] = 60;
            this.dynamicNumbers[18] = 120;
          } else if (!this.currentTable[i + 4]) {
            this.dynamicNumbers[6] = 40;
            this.dynamicNumbers[12] = 50;
            this.dynamicNumbers[18] = 60;
          } else if (!this.currentTable[i + 5]) {
            this.dynamicNumbers[6] = 35;
            this.dynamicNumbers[12] = 40;
            this.dynamicNumbers[18] = 50;
          } else if (!this.currentTable[i + 6]) {
            this.dynamicNumbers[6] = 30;
            this.dynamicNumbers[12] = 35;
            this.dynamicNumbers[18] = 40;
          } else if (!this.currentTable[i + 7]) {
            this.dynamicNumbers[6] = 29;
            this.dynamicNumbers[12] = 30;
            this.dynamicNumbers[18] = 35;
          }

          if (this.calculationData.answer === 'No') {
            this.dynamicNumbers[1] = 0.1;
            this.dynamicNumbers[2] = 0.05;
            this.dynamicNumbers[3] = 0.025;
            this.dynamicNumbers[4] = 0.01;
            this.dynamicNumbers[5] = 0.005;
          }

          if (this.currentTable[i][y + 2] !== undefined
           && this.currentTable[i][y - 2] !== undefined
           && this.currentTable[i - 1] !== undefined
           && this.currentTable[i + 1] !== undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i - 1][y - 2];
            this.dynamicNumbers[8] = this.currentTable[i - 1][y - 1];
            this.dynamicNumbers[9] = this.currentTable[i - 1][y];
            this.dynamicNumbers[10] = this.currentTable[i - 1][y + 1];
            this.dynamicNumbers[11] = this.currentTable[i - 1][y + 2];

            this.dynamicNumbers[13] = this.currentTable[i][y - 2];
            this.dynamicNumbers[14] = this.currentTable[i][y - 1];
            this.dynamicNumbers[15] = this.currentTable[i][y];
            this.dynamicNumbers[16] = this.currentTable[i][y + 1];
            this.dynamicNumbers[17] = this.currentTable[i][y + 2];

            this.dynamicNumbers[19] = this.currentTable[i + 1][y - 2];
            this.dynamicNumbers[20] = this.currentTable[i + 1][y - 1];
            this.dynamicNumbers[21] = this.currentTable[i + 1][y];
            this.dynamicNumbers[22] = this.currentTable[i + 1][y + 1];
            this.dynamicNumbers[23] = this.currentTable[i + 1][y + 2];
          } else if (this.currentTable[i][y - 2] === undefined
            && this.currentTable[i - 1] !== undefined
            && this.currentTable[i + 1] !== undefined
            && this.currentTable[i][y - 1] !== undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i - 1][y - 1];
            this.dynamicNumbers[8] = this.currentTable[i - 1][y];
            this.dynamicNumbers[9] = this.currentTable[i - 1][y + 1];
            this.dynamicNumbers[10] = this.currentTable[i - 1][y + 2];
            this.dynamicNumbers[11] = this.currentTable[i - 1][y + 3];

            this.dynamicNumbers[13] = this.currentTable[i][y - 1];
            this.dynamicNumbers[14] = this.currentTable[i][y];
            this.dynamicNumbers[15] = this.currentTable[i][y + 1];
            this.dynamicNumbers[16] = this.currentTable[i][y + 2];
            this.dynamicNumbers[17] = this.currentTable[i][y + 3];

            this.dynamicNumbers[19] = this.currentTable[i + 1][y - 1];
            this.dynamicNumbers[20] = this.currentTable[i + 1][y];
            this.dynamicNumbers[21] = this.currentTable[i + 1][y + 1];
            this.dynamicNumbers[22] = this.currentTable[i + 1][y + 2];
            this.dynamicNumbers[23] = this.currentTable[i + 1][y + 3];
          } else if (this.currentTable[i][y + 2] === undefined
            && this.currentTable[i - 1] !== undefined
            && this.currentTable[i + 1] !== undefined
            && this.currentTable[i][y + 1] !== undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i - 1][y - 3];
            this.dynamicNumbers[8] = this.currentTable[i - 1][y - 2];
            this.dynamicNumbers[9] = this.currentTable[i - 1][y - 1];
            this.dynamicNumbers[10] = this.currentTable[i - 1][y];
            this.dynamicNumbers[11] = this.currentTable[i - 1][y + 1];

            this.dynamicNumbers[13] = this.currentTable[i][y - 3];
            this.dynamicNumbers[14] = this.currentTable[i][y - 2];
            this.dynamicNumbers[15] = this.currentTable[i][y - 1];
            this.dynamicNumbers[16] = this.currentTable[i][y];
            this.dynamicNumbers[17] = this.currentTable[i][y + 1];

            this.dynamicNumbers[19] = this.currentTable[i + 1][y - 3];
            this.dynamicNumbers[20] = this.currentTable[i + 1][y - 2];
            this.dynamicNumbers[21] = this.currentTable[i + 1][y - 1];
            this.dynamicNumbers[22] = this.currentTable[i + 1][y];
            this.dynamicNumbers[23] = this.currentTable[i + 1][y + 1];
          } else if (this.currentTable[i][y - 1] === undefined
            && this.currentTable[i - 1] !== undefined
            && this.currentTable[i + 1] !== undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i - 1][y];
            this.dynamicNumbers[8] = this.currentTable[i - 1][y + 1];
            this.dynamicNumbers[9] = this.currentTable[i - 1][y + 2];
            this.dynamicNumbers[10] = this.currentTable[i - 1][y + 3];
            this.dynamicNumbers[11] = this.currentTable[i - 1][y + 4];

            this.dynamicNumbers[13] = this.currentTable[i][y];
            this.dynamicNumbers[14] = this.currentTable[i][y + 1];
            this.dynamicNumbers[15] = this.currentTable[i][y + 2];
            this.dynamicNumbers[16] = this.currentTable[i][y + 3];
            this.dynamicNumbers[17] = this.currentTable[i][y + 4];

            this.dynamicNumbers[19] = this.currentTable[i + 1][y];
            this.dynamicNumbers[20] = this.currentTable[i + 1][y + 1];
            this.dynamicNumbers[21] = this.currentTable[i + 1][y + 2];
            this.dynamicNumbers[22] = this.currentTable[i + 1][y + 3];
            this.dynamicNumbers[23] = this.currentTable[i + 1][y + 4];
          } else if (this.currentTable[i][y + 1] === undefined
            && this.currentTable[i - 1] !== undefined
            && this.currentTable[i + 1] !== undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i - 1][y - 4];
            this.dynamicNumbers[8] = this.currentTable[i - 1][y - 3];
            this.dynamicNumbers[9] = this.currentTable[i - 1][y - 2];
            this.dynamicNumbers[10] = this.currentTable[i - 1][y - 1];
            this.dynamicNumbers[11] = this.currentTable[i - 1][y];

            this.dynamicNumbers[13] = this.currentTable[i][y - 4];
            this.dynamicNumbers[14] = this.currentTable[i][y - 3];
            this.dynamicNumbers[15] = this.currentTable[i][y - 2];
            this.dynamicNumbers[16] = this.currentTable[i][y - 1];
            this.dynamicNumbers[17] = this.currentTable[i][y];

            this.dynamicNumbers[19] = this.currentTable[i + 1][y - 4];
            this.dynamicNumbers[20] = this.currentTable[i + 1][y - 3];
            this.dynamicNumbers[21] = this.currentTable[i + 1][y - 2];
            this.dynamicNumbers[22] = this.currentTable[i + 1][y - 1];
            this.dynamicNumbers[23] = this.currentTable[i + 1][y];
          } else if (this.currentTable[i][y + 2] !== undefined
           && this.currentTable[i][y - 2] !== undefined
           && this.currentTable[i - 1] === undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i][y - 2];
            this.dynamicNumbers[8] = this.currentTable[i][y - 1];
            this.dynamicNumbers[9] = this.currentTable[i][y];
            this.dynamicNumbers[10] = this.currentTable[i][y + 1];
            this.dynamicNumbers[11] = this.currentTable[i][y + 2];

            this.dynamicNumbers[13] = this.currentTable[i + 1][y - 2];
            this.dynamicNumbers[14] = this.currentTable[i + 1][y - 1];
            this.dynamicNumbers[15] = this.currentTable[i + 1][y];
            this.dynamicNumbers[16] = this.currentTable[i + 1][y + 1];
            this.dynamicNumbers[17] = this.currentTable[i + 1][y + 2];

            this.dynamicNumbers[19] = this.currentTable[i + 2][y - 2];
            this.dynamicNumbers[20] = this.currentTable[i + 2][y - 1];
            this.dynamicNumbers[21] = this.currentTable[i + 2][y];
            this.dynamicNumbers[22] = this.currentTable[i + 2][y + 1];
            this.dynamicNumbers[23] = this.currentTable[i + 2][y + 2];
          } else if (this.currentTable[i][y + 2] !== undefined
           && this.currentTable[i][y - 2] !== undefined
           && this.currentTable[i + 1] === undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i - 2][y - 2];
            this.dynamicNumbers[8] = this.currentTable[i - 2][y - 1];
            this.dynamicNumbers[9] = this.currentTable[i - 2][y];
            this.dynamicNumbers[10] = this.currentTable[i - 2][y + 1];
            this.dynamicNumbers[11] = this.currentTable[i - 2][y + 2];

            this.dynamicNumbers[13] = this.currentTable[i - 1][y - 2];
            this.dynamicNumbers[14] = this.currentTable[i - 1][y - 1];
            this.dynamicNumbers[15] = this.currentTable[i - 1][y];
            this.dynamicNumbers[16] = this.currentTable[i - 1][y + 1];
            this.dynamicNumbers[17] = this.currentTable[i - 1][y + 2];

            this.dynamicNumbers[19] = this.currentTable[i][y - 2];
            this.dynamicNumbers[20] = this.currentTable[i][y - 1];
            this.dynamicNumbers[21] = this.currentTable[i][y];
            this.dynamicNumbers[22] = this.currentTable[i][y + 1];
            this.dynamicNumbers[23] = this.currentTable[i][y + 2];
          } else if (this.currentTable[i][y + 2] === undefined
           && this.currentTable[i][y + 1] !== undefined
           && this.currentTable[i + 1] === undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i - 2][y - 3];
            this.dynamicNumbers[8] = this.currentTable[i - 2][y - 2];
            this.dynamicNumbers[9] = this.currentTable[i - 2][y - 1];
            this.dynamicNumbers[10] = this.currentTable[i - 2][y];
            this.dynamicNumbers[11] = this.currentTable[i - 2][y + 1];

            this.dynamicNumbers[13] = this.currentTable[i - 1][y - 3];
            this.dynamicNumbers[14] = this.currentTable[i - 1][y - 2];
            this.dynamicNumbers[15] = this.currentTable[i - 1][y - 1];
            this.dynamicNumbers[16] = this.currentTable[i - 1][y];
            this.dynamicNumbers[17] = this.currentTable[i - 1][y + 1];

            this.dynamicNumbers[19] = this.currentTable[i][y - 3];
            this.dynamicNumbers[20] = this.currentTable[i][y - 2];
            this.dynamicNumbers[21] = this.currentTable[i][y - 1];
            this.dynamicNumbers[22] = this.currentTable[i][y];
            this.dynamicNumbers[23] = this.currentTable[i][y + 1];
          } else if (this.currentTable[i][y + 2] !== undefined
           && this.currentTable[i][y - 1] !== undefined
           && this.currentTable[i - 1] === undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i][y - 1];
            this.dynamicNumbers[8] = this.currentTable[i][y];
            this.dynamicNumbers[9] = this.currentTable[i][y + 1];
            this.dynamicNumbers[10] = this.currentTable[i][y + 2];
            this.dynamicNumbers[11] = this.currentTable[i][y + 3];

            this.dynamicNumbers[13] = this.currentTable[i + 1][y - 1];
            this.dynamicNumbers[14] = this.currentTable[i + 1][y];
            this.dynamicNumbers[15] = this.currentTable[i + 1][y + 1];
            this.dynamicNumbers[16] = this.currentTable[i + 1][y + 2];
            this.dynamicNumbers[17] = this.currentTable[i + 1][y + 3];

            this.dynamicNumbers[19] = this.currentTable[i + 2][y - 1];
            this.dynamicNumbers[20] = this.currentTable[i + 2][y];
            this.dynamicNumbers[21] = this.currentTable[i + 2][y + 1];
            this.dynamicNumbers[22] = this.currentTable[i + 2][y + 2];
            this.dynamicNumbers[23] = this.currentTable[i + 2][y + 3];
          } else if (this.currentTable[i][y + 2] !== undefined
           && this.currentTable[i][y - 1] === undefined
           && this.currentTable[i - 1] === undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i][y];
            this.dynamicNumbers[8] = this.currentTable[i][y + 1];
            this.dynamicNumbers[9] = this.currentTable[i][y + 2];
            this.dynamicNumbers[10] = this.currentTable[i][y + 3];
            this.dynamicNumbers[11] = this.currentTable[i][y + 4];

            this.dynamicNumbers[13] = this.currentTable[i + 1][y];
            this.dynamicNumbers[14] = this.currentTable[i + 1][y + 1];
            this.dynamicNumbers[15] = this.currentTable[i + 1][y + 2];
            this.dynamicNumbers[16] = this.currentTable[i + 1][y + 3];
            this.dynamicNumbers[17] = this.currentTable[i + 1][y + 4];

            this.dynamicNumbers[19] = this.currentTable[i + 2][y];
            this.dynamicNumbers[20] = this.currentTable[i + 2][y + 1];
            this.dynamicNumbers[21] = this.currentTable[i + 2][y + 2];
            this.dynamicNumbers[22] = this.currentTable[i + 2][y + 3];
            this.dynamicNumbers[23] = this.currentTable[i + 2][y + 4];
          } else if (this.currentTable[i][y + 2] !== undefined
           && this.currentTable[i][y - 2] !== undefined
           && this.currentTable[i - 1] === undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i][y - 3];
            this.dynamicNumbers[8] = this.currentTable[i][y - 2];
            this.dynamicNumbers[9] = this.currentTable[i][y - 1];
            this.dynamicNumbers[10] = this.currentTable[i][y];
            this.dynamicNumbers[11] = this.currentTable[i][y + 1];

            this.dynamicNumbers[13] = this.currentTable[i + 1][y - 3];
            this.dynamicNumbers[14] = this.currentTable[i + 1][y - 2];
            this.dynamicNumbers[15] = this.currentTable[i + 1][y - 1];
            this.dynamicNumbers[16] = this.currentTable[i + 1][y];
            this.dynamicNumbers[17] = this.currentTable[i + 1][y + 1];

            this.dynamicNumbers[19] = this.currentTable[i + 2][y - 3];
            this.dynamicNumbers[20] = this.currentTable[i + 2][y - 2];
            this.dynamicNumbers[21] = this.currentTable[i + 2][y - 1];
            this.dynamicNumbers[22] = this.currentTable[i + 2][y];
            this.dynamicNumbers[23] = this.currentTable[i + 2][y + 1];
          } else if (this.currentTable[i][y + 1] === undefined
           && this.currentTable[i][y - 2] !== undefined
           && this.currentTable[i - 1] === undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i][y - 4];
            this.dynamicNumbers[8] = this.currentTable[i][y - 3];
            this.dynamicNumbers[9] = this.currentTable[i][y - 2];
            this.dynamicNumbers[10] = this.currentTable[i][y - 1];
            this.dynamicNumbers[11] = this.currentTable[i][y];

            this.dynamicNumbers[13] = this.currentTable[i + 1][y - 4];
            this.dynamicNumbers[14] = this.currentTable[i + 1][y - 4];
            this.dynamicNumbers[15] = this.currentTable[i + 1][y - 2];
            this.dynamicNumbers[16] = this.currentTable[i + 1][y - 1];
            this.dynamicNumbers[17] = this.currentTable[i + 1][y];

            this.dynamicNumbers[19] = this.currentTable[i + 2][y - 4];
            this.dynamicNumbers[20] = this.currentTable[i + 2][y - 3];
            this.dynamicNumbers[21] = this.currentTable[i + 2][y - 2];
            this.dynamicNumbers[22] = this.currentTable[i + 2][y - 1];
            this.dynamicNumbers[23] = this.currentTable[i + 2][y];
          } else if (this.currentTable[i][y - 1] === undefined
           && this.currentTable[i][y + 2] !== undefined
           && this.currentTable[i + 1] === undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i - 2][y];
            this.dynamicNumbers[8] = this.currentTable[i - 2][y + 1];
            this.dynamicNumbers[9] = this.currentTable[i - 2][y + 2];
            this.dynamicNumbers[10] = this.currentTable[i - 2][y + 3];
            this.dynamicNumbers[11] = this.currentTable[i - 2][y + 4];

            this.dynamicNumbers[13] = this.currentTable[i - 1][y];
            this.dynamicNumbers[14] = this.currentTable[i - 1][y + 1];
            this.dynamicNumbers[15] = this.currentTable[i - 1][y + 2];
            this.dynamicNumbers[16] = this.currentTable[i - 1][y + 3];
            this.dynamicNumbers[17] = this.currentTable[i - 1][y + 4];

            this.dynamicNumbers[19] = this.currentTable[i][y];
            this.dynamicNumbers[20] = this.currentTable[i][y + 1];
            this.dynamicNumbers[21] = this.currentTable[i][y + 2];
            this.dynamicNumbers[22] = this.currentTable[i][y + 3];
            this.dynamicNumbers[23] = this.currentTable[i][y + 4];
          } else if (this.currentTable[i][y + 1] === undefined
           && this.currentTable[i + 1] === undefined
          ) {
            this.dynamicNumbers[7] = this.currentTable[i - 2][y - 4];
            this.dynamicNumbers[8] = this.currentTable[i - 2][y - 3];
            this.dynamicNumbers[9] = this.currentTable[i - 2][y - 2];
            this.dynamicNumbers[10] = this.currentTable[i - 2][y - 1];
            this.dynamicNumbers[11] = this.currentTable[i - 2][y];

            this.dynamicNumbers[13] = this.currentTable[i - 1][y - 4];
            this.dynamicNumbers[14] = this.currentTable[i - 1][y - 3];
            this.dynamicNumbers[15] = this.currentTable[i - 1][y - 2];
            this.dynamicNumbers[16] = this.currentTable[i - 1][y - 1];
            this.dynamicNumbers[17] = this.currentTable[i - 1][y];

            this.dynamicNumbers[19] = this.currentTable[i][y - 4];
            this.dynamicNumbers[20] = this.currentTable[i][y - 3];
            this.dynamicNumbers[21] = this.currentTable[i][y - 2];
            this.dynamicNumbers[22] = this.currentTable[i][y - 1];
            this.dynamicNumbers[23] = this.currentTable[i][y];
          }

          const dynamicNumbersArr = Object.entries(this.dynamicNumbers);

          for (let h = 0; h < dynamicNumbersArr.length; h += 1) {
            if (dynamicNumbersArr[h][1] === this.currentScore) {
              this.isActive[`score${dynamicNumbersArr[h][0]}`] = true;

              let currentRow = [];

              if ([
                this.dynamicNumbers[7],
                this.dynamicNumbers[8],
                this.dynamicNumbers[9],
                this.dynamicNumbers[10],
                this.dynamicNumbers[11],
              ].includes(this.currentScore)
              ) {
                currentRow = [6, 7, 8, 9, 10, 11];
              } else if (
                [
                  this.dynamicNumbers[13],
                  this.dynamicNumbers[14],
                  this.dynamicNumbers[15],
                  this.dynamicNumbers[16],
                  this.dynamicNumbers[17],
                ].includes(this.currentScore)
              ) {
                currentRow = [12, 13, 14, 15, 16, 17];
              } else {
                currentRow = [18, 19, 20, 21, 22, 23];
              }

              for (let p = 0; p < currentRow.length; p += 1) {
                if (!this.isActive[`score${currentRow[p]}`]) {
                  this.isActive[currentRow[p]] = true;
                } else if (!this.currentTable[i - 1]) {
                  this.isActive[currentRow[p] + 6] = true;
                  this.isActive[currentRow[p] + 12] = true;
                } else if (this.currentTable[i - 1] && this.currentTable[i + 1]) {
                  this.isActive[currentRow[p] - 6] = true;
                  this.isActive[currentRow[p] + 6] = true;
                } else if (!this.currentTable[i + 1]) {
                  this.isActive[currentRow[p] - 6] = true;
                  this.isActive[currentRow[p] - 12] = true;
                }
              }

              break;
            }
          }

          breakLoops = true;
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.currentTable {
  margin: var(--spacing-44) 0;

  .name {
    display: flex;
    justify-content: center;
    color: var(--accent-shade-2);
    margin-bottom: var(--spacing-4);
    margin-top: var(--spacing-12);

    .t-table {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: var(--spacing-16);

      h4 {
        margin-bottom: var(--spacing-12);
      }

      span {
        font-size: 21px;
        line-height: 140%;
      }
    }
  }

  .table-wrapper {
    width: 100%;
    border-radius: 4px;
    overflow: hidden;

    table {
      border-collapse: collapse;
      width: 100%;

      tr {
        height: 46px;

        .current-score {
          background: var(--accent-light-3);
        }

        .color {
          background: var(--accent-light-2);
        }

        th,
        td {
          border: 2px solid var(--accent-shade-2);
          text-align: center;
          vertical-align: middle;
        }

        th {
          width: 18%;
          background: var(--accent-shade-1);
          color: var(--main-light);
          font-weight: 400;
        }

        th:nth-child(1) {
          width: 12%;
        }
      }

      h4 {
        color: var(--accent-shade-3);
      }
    }
  }
}

@include bp($bp-phone) {
  .currentTable {
    .name {
      h4 {
        font-size: 21px;

        &.snd-name {
          text-align: center;
        }
      }

      .t-table span {
        font-size: 18px;
      }
    }

    .table-wrapper table tr {
      th,
      td {
        font-size: 14px;
      }

      th {
        width: 12%;
      }

      th:nth-child(1) {
        width: 10%;
      }
    }
  }
}
</style>
